
// vue
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Divider',
  setup(_, { emit }) {
    const leftWidth = ref(60);
    const dragEvent = (e: MouseEvent) => {
      // 画面左端から何パーセントの位置にあるか
      const percentage =
        Math.round((e.clientX / window.innerWidth) * 1000) / 10;
      if (percentage === 0) return;

      leftWidth.value = percentage;

      emit('changePosition', leftWidth.value);
    };
    const dragEnd = (e: MouseEvent) => {
      const percentage =
        Math.round((e.clientX / window.innerWidth) * 1000) / 10;
      if (percentage === 0) return;

      leftWidth.value = percentage;
      emit('changePosition', leftWidth.value);
    };

    return {
      dragEvent,
      dragEnd,
    };
  },
});
